import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';

export interface QuestionDialogProps {
    onClose: (accept: boolean) => void;
    open: boolean;
    title: string;
    question: string;
}
export default function QuestionDialog(props: QuestionDialogProps, ref: any) {
    const { onClose, open, title, question } = props;

    // const [open, setOpen] = React.useState(false);
    const handleClose = (e: boolean) => {
        onClose(e);
    };

    return (
        <Dialog
            open={open}
            onClose={() => { handleClose(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {question}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => { handleClose(false) }}>{'NE'}</Button>
                <Button onClick={() => { handleClose(true) }} autoFocus>
                    {'ANO'}
                </Button>
            </DialogActions>
        </Dialog>);
}